import axios from 'axios'

export interface IGetIconSearchPrams {
  query: string
  prefixes?: string[]
  prefix?: string
  limit?: number
  start?: number
}
export interface IGetIconSearchData {
  icons: string[]
}
export const getIconSearch = (params: IGetIconSearchPrams) =>
  axios.get<IGetIconSearchData>('https://api.iconify.design/search', { params })

export interface IGetIconCollectionPrams {
  query: string
  prefix: string
  limit?: number
  start?: number
}
export interface IGetIconCollectionData {
  icons: string[]
}
export const getIconCollection = (params: IGetIconCollectionPrams) =>
  axios.get<IGetIconCollectionData>('https://api.iconify.design/search', {
    params,
  })
